import { render, staticRenderFns } from "./NameAndNumber.vue?vue&type=template&id=6d402605&scoped=true"
import script from "./NameAndNumber.vue?vue&type=script&lang=js"
export * from "./NameAndNumber.vue?vue&type=script&lang=js"
import style0 from "./NameAndNumber.vue?vue&type=style&index=0&id=6d402605&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d402605",
  null
  
)

export default component.exports